import React, { useEffect, useState } from "react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { getAuth, getDashboardPath, getLoginPath, isAllowedRole } from "../auth";

const roleLabels = {
  admin: "admin",
  employer: "employer",
  seeker: "candidate",
};

const isPanelRoute = (path = "") => {
  return path.startsWith("/admin-") || path.startsWith("/employee-") || path.startsWith("/candidate-");
};

const RoleRestrictionNotice = ({ user, allowedRoles }) => {
  const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
  const allowedLabel = roles.map((item) => roleLabels[item] ?? item).join(" or ");
  const currentLabel = roleLabels[user?.role] ?? "current";

  return (
    <section className="ls-section protected-route-section">
      <div className="auto-container">
        <div className="employee-empty-state">
          <h4 style={{ marginBottom: 8 }}>This area is for {allowedLabel} accounts.</h4>
          <p style={{ marginBottom: 18 }}>
            You are logged in as a {currentLabel}. Please use the correct account type for this action.
          </p>
          <Link to={getDashboardPath(user)} className="theme-btn btn-style-one">
            Go to My Dashboard
          </Link>
          <Link to="/" className="theme-btn btn-style-three" style={{ marginLeft: 12 }}>
            Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

const ProtectedRoute = ({ role, roles }) => {
  const location = useLocation();
  const [auth, setAuth] = useState(getAuth());
  const { isLoggedIn, user } = auth;
  const allowedRoles = roles ?? role;

  useEffect(() => {
    const syncAuth = () => setAuth(getAuth());

    window.addEventListener("auth-change", syncAuth);
    window.addEventListener("storage", syncAuth);

    return () => {
      window.removeEventListener("auth-change", syncAuth);
      window.removeEventListener("storage", syncAuth);
    };
  }, []);

  if (!isLoggedIn) {
    return <Navigate to={isPanelRoute(location.pathname) ? "/login" : getLoginPath(location.pathname)} replace state={{ from: location.pathname }} />;
  }

  if (!isAllowedRole(user, allowedRoles)) {
    return <RoleRestrictionNotice user={user} allowedRoles={allowedRoles} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
